import React from "react";
import AboutUslot from "./AboutUslot";
import AboutFeatures from "./AboutFeatures";
import HowItWorks from "./HowItWorks";
import ForYou from "./ForYou";
import OurTeam from "./OurTeam";
import AboutTestimonials from "./AboutTestimonials";
import "./index.css";
import HeroAbout from "./HeroAbout";
import Footer from "../Footer/Footer";
import Lheader from "../Landingpageheader/Lheader";

const AboutPage = () => {
  return (
    <>
      <Lheader />
      <main>
        <HeroAbout />
        <AboutUslot />
        <AboutFeatures />
        {/* <HowItWorks /> */}
        <ForYou />
        <OurTeam />
        {/* <AboutTestimonials /> */}
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
